/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HousingDto } from '../../models/housing-dto';

export interface HousingControllerFindOne$Params {
  id: number;
}

export function housingControllerFindOne(http: HttpClient, rootUrl: string, params: HousingControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<HousingDto>> {
  const rb = new RequestBuilder(rootUrl, housingControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HousingDto>;
    })
  );
}

housingControllerFindOne.PATH = '/api/housing/{id}';
